import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import { login, getUserListAll } from '@/api/user';
import { jsonInBlacklist } from '@/api/jwt';
import router from '@/router/index';
export var user = {
  namespaced: true,
  state: {
    userInfo: {
      uuid: "",
      nickName: "",
      headerImg: "",
      authority: ""
    },
    userMap: {},
    token: "",
    isInit: 0
  },
  mutations: {
    setUserInfo: function setUserInfo(state, userInfo) {
      // 这里的 `state` 对象是模块的局部状态
      state.userInfo = userInfo;
    },
    setToken: function setToken(state, token) {
      // 这里的 `state` 对象是模块的局部状态
      state.token = token;
    },
    NeedInit: function NeedInit(state) {
      state.userInfo = {};
      state.token = "";
      sessionStorage.clear();
      router.push({
        name: 'init',
        replace: true
      });
    },
    LoginOut: function LoginOut(state) {
      state.userInfo = {};
      state.token = "";
      sessionStorage.clear();
      router.push({
        name: 'login',
        replace: true
      });
      window.location.reload();
    },
    ResetUserInfo: function ResetUserInfo(state) {
      var userInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      state.userInfo = _objectSpread(_objectSpread({}, state.userInfo), userInfo);
    },
    setUserMap: function setUserMap(state, userMap) {
      state.isInit = 1;
      state.userMap = userMap;
    }
  },
  actions: {
    LoginIn: function LoginIn(_ref, loginInfo) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, dispatch, rootGetters, getters, res, asyncRouters;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, dispatch = _ref.dispatch, rootGetters = _ref.rootGetters, getters = _ref.getters;
              _context.next = 3;
              return login(loginInfo);
            case 3:
              res = _context.sent;
              if (!(res.code == 0)) {
                _context.next = 14;
                break;
              }
              console.log("res.data.user", res.data.user);
              commit('setUserInfo', res.data.user);
              commit('setToken', res.data.token);
              _context.next = 10;
              return dispatch('router/SetAsyncRouter', {}, {
                root: true
              });
            case 10:
              asyncRouters = rootGetters['router/asyncRouters'];
              router.addRoutes(asyncRouters);
              // const redirect = router.history.current.query.redirect
              // console.log(redirect)
              // if (redirect) {
              //     router.push({ path: redirect })
              // } else {
              // 强制默认首页
              // router.push({ name: getters["userInfo"].authority.defaultRouter })
              router.push({
                name: 'dashboard'
              });
              // }
              return _context.abrupt("return", true);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    LoginOut: function LoginOut(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var commit, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return jsonInBlacklist();
            case 3:
              res = _context2.sent;
              if (res.code == 0) {
                commit("LoginOut");
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getUserMap: function getUserMap(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var commit, state, res, userMap;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state;
              if (!(state.isInit == 1)) {
                _context3.next = 6;
                break;
              }
              _context3.next = 4;
              return getUserListAll();
            case 4:
              res = _context3.sent;
              if (res.code == 0) {
                userMap = {};
                res.data.list.forEach(function (val) {
                  userMap[val.ID.toString()] = val.nickName;
                });
                commit("setUserMap", userMap);
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  getters: {
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    getUserMap: function getUserMap(state) {
      return state.userMap;
    },
    token: function token(state) {
      return state.token;
    }
  }
};